
import React from 'react';

const Hero: React.FC = () => {
    return (
        <main id="home" className="hero">
            <div className="container">
                <div className="hero-content">
                    <div className="hero-logo-small">M.Y.</div>
                    <h2>PROGRAMAÇÃO DE CLP & AUTOMAÇÃO INDUSTRIAL</h2>
                    <p>M.Y Soluções Industriais | Especialista em Controle de Movimento (Motion Control). Soluções em Programação de CLP e Parametrização de Inversores de Frequência. Aumente a eficiência da sua indústria.</p>
                    <a href="#contact" className="btn-outline">Fale conosco</a>
                </div>
            </div>
        </main>
    );
};

export default Hero;
